import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'fb-field-tooltip',
  template: `<mat-icon>{{ icon }}</mat-icon>
    <div class="tooltiptext"><ng-content></ng-content></div>`,
  styleUrls: ['./field-tooltip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FieldTooltipComponent {
  @Input() icon: string = 'help_outline';
}
